function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type};
/* tjs <- deep-clone.ts */

import { XinObject, XinArray, AnyFunction } from './xin-types'

const Scalar = Type('Scalar')

const Cloneable = Type('Cloneable')

/* line 6 */
/* TODO: TS types degraded — obj: Cloneable, return: Cloneable | Cloneable[] */
export function deepClone(obj) {
    if (obj == null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Set) {
        return new Set(obj);
    }
    else if (Array.isArray(obj)) {
        return obj.map(deepClone);
    }
    const clone = {};
    for (const key in obj) {
        const val = obj[key];
        if (obj != null && typeof obj === 'object') {
            clone[key] = deepClone(val);
        }
        else {
            clone[key] = val;
        }
    }
    return clone;
}
deepClone.__tjs = {
  "params": {
    "obj": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "deep-clone.ts:11"
}